import { AutogenModelCarrierLookup, AutogenRowCarrierLookup } from "./autogen/AutogenModelCarrierLookup";

export class ModelCarrierLookup extends AutogenModelCarrierLookup<RowCarrierLookup> {
	constructor() {
		super(RowCarrierLookup);
	}
}

export class RowCarrierLookup extends AutogenRowCarrierLookup {
}